import gql from "graphql-tag";
import { PRODUCT_MEDIA_FIELDS } from "./fragments";

export const PRODUCT_DETAILS_QUERY = gql`
  query ($handle: String!) {
    productByHandle(handle: $handle) {
      id
      handle
      title
      description
      descriptionHtml
      engraving_cost: metafield(namespace: "custom", key: "engraving_cost") {
        key
        value
      }
      leadShippingTime: metafield(namespace: "custom", key: "lead_shipping_time_engraving_") {
        key
        value
      }
      minimumCharacter: metafield(namespace: "custom", key: "minimum_characters_engraving_"){
        key
        value
      }
      maximumCharacter: metafield(namespace: "custom", key: "maximum_characters_engraving_"){
        key
        value
      }
      engraveFonts: metafield(namespace: "custom", key: "engrave_fonts"){
        key
        type
        value
         references(first: 10){
          ... on MetafieldReferenceConnection{
            nodes{
              ... on Metaobject{
                id
                fields{
                  key
                  value
                }
                
              }
            }
          }
        }
        }
      featuredImage {
        src
        height
        width
        id
        altText
      }
      bundle_image:metafield(key: "bundle_image", namespace: "custom") {
        key
        reference {
          ... on MediaImage {
            id
            image {
              height
              width
              src
              altText
            }
          }
        }
      }
      bundle_products: metafield(key: "bundle_products", namespace: "custom") {
        value
        key
        namespace
        references(first: 10) {
          edges {
            node {
              ... on Product {
                id
                handle
                title
                description
                descriptionHtml
                featuredImage {
                  src
                  height
                  width
                  id
                  altText
                }
                seo {
                  title
                  description
                }
                media(first: 100) {
                  edges {
                    node {
                      mediaContentType
                      alt
                      previewImage {
                        altText
                        url (transform: { maxHeight: 628, maxWidth: 1200 })
                      }
                      ...mediaFieldsByType
                    }
                  }
                }
                tags
                productType
                vendor
                availableForSale
                product_type: metafield(namespace: "my_fields", key: "product_type") {
                  key
                  value
                }
                variants(first: 100) {
                  edges {
                    node {
                      id
                      title
                      barcode
                      priceV2 {
                        amount
                      }
                      compareAtPriceV2 {
                        amount
                      }
                      selectedOptions {
                        name
                        value
                      }
                      image {
                        src
                        url
                        id
                        height
                        width
                        altText
                      }
                      product {
                        tags

                      }
                      availableForSale
                      quantityAvailable
                      sku
                      hexColor: metafield(namespace: "color", key: "hexcolor") {
                        key
                        value
                      }
                      olivela_cost: metafield(namespace: "my_fields", key: "olivela_cost") {
                        key
                        value
                      }
                      local_item: metafield(namespace: "my_fields", key: "local_item") {
                        key
                        value
                      }
                      baseColor: metafield(namespace: "color", key: "base_color") {
                        key
                        value
                      }
                    }
                  }
                }
                collections(first: 10) {
                  edges {
                    node {
                      id
                    }
                  }
                }
                options(first: 100) {
                  id
                  name
                  values
                }
              }
            }
          }
        }
      }
      seo {
        title
        description
      }
      media(first: 100) {
        edges {
          node {
            mediaContentType
            alt
            previewImage {
              altText
              url (transform: { maxHeight: 628, maxWidth: 1200 })
            }
            ...mediaFieldsByType
          }
        }
      }
      tags
      productType
      vendor
      availableForSale
      product_type: metafield(namespace: "my_fields", key: "product_type") {
        key
        value
      }
      variants(first: 200) {
        edges {
          node {
            id
            title
            barcode
            priceV2 {
              amount
            }
            compareAtPriceV2 {
              amount
            }
            selectedOptions {
              name
              value
            }
            image {
              src
              url
              id
              height
              width
              altText
            }
            product {
              tags

            }
            availableForSale
            quantityAvailable
            sku
            hexColor: metafield(namespace: "color", key: "hexcolor") {
              key
              value
            }
             metalColor: metafield(namespace: "color", key: "metal_color") {
              key
              value
            }
            olivela_cost: metafield(namespace: "my_fields", key: "olivela_cost") {
              key
              value
            }
            local_item: metafield(namespace: "my_fields", key: "local_item") {
              key
             value
            }
            baseColor: metafield(namespace: "color", key: "base_color") {
              key
              value
            }
          }
        }
      }
      collections(first: 100) {
        edges {
          node {
            id
          }
        }
      }
      options(first: 100) {
        id
        name
        values
      }
    }
  }
  ${PRODUCT_MEDIA_FIELDS}
`;

export const MULTIPLE_PRODUCT_DETAILS_QUERY = gql`
  query ($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        handle
        title
        description
        descriptionHtml
        featuredImage {
          src
          height
          width
          id
          altText
        }
        bundle_image: metafield(key: "bundle_image", namespace: "custom") {
          key
          reference {
            ... on MediaImage {
              id
              image {
                height
                width
                src
                altText
              }
            }
          }
        }
        bundle_products: metafield(
          key: "bundle_products"
          namespace: "custom"
        ) {
          value
          key
          namespace
          references(first: 10) {
            edges {
              node {
                ... on Product {
                  id
                  handle
                  title
                  description
                  descriptionHtml
                  featuredImage {
                    src
                    height
                    width
                    id
                    altText
                  }
                  seo {
                    title
                    description
                  }
                  media(first: 100) {
                    edges {
                      node {
                        mediaContentType
                        alt
                        previewImage {
                          altText
                          url(transform: { maxHeight: 628, maxWidth: 1200 })
                        }
                        ...mediaFieldsByType
                      }
                    }
                  }
                  tags
                  productType
                  vendor
                  availableForSale
                  product_type: metafield(
                    namespace: "my_fields"
                    key: "product_type"
                  ) {
                    key
                    value
                  }
                  variants(first: 100) {
                    edges {
                      node {
                        id
                        title
                        barcode
                        priceV2 {
                          amount
                        }
                        compareAtPriceV2 {
                          amount
                        }
                        selectedOptions {
                          name
                          value
                        }
                        image {
                          src
                          url
                          id
                          height
                          width
                          altText
                        }
                        product {
                          tags
                        }
                        availableForSale
                        quantityAvailable
                        sku
                        hexColor: metafield(
                          namespace: "color"
                          key: "hexcolor"
                        ) {
                          key
                          value
                        }
                        olivela_cost: metafield(
                          namespace: "my_fields"
                          key: "olivela_cost"
                        ) {
                          key
                          value
                        }
                        baseColor: metafield(namespace: "color", key: "base_color") {
                          key
                          value
                        }
                      }
                    }
                  }
                  collections(first: 10) {
                    edges {
                      node {
                        id
                      }
                    }
                  }
                  options(first: 100) {
                    id
                    name
                    values
                  }
                }
              }
            }
          }
        }
        seo {
          title
          description
        }
        media(first: 100) {
          edges {
            node {
              mediaContentType
              alt
              previewImage {
                altText
                url(transform: { maxHeight: 628, maxWidth: 1200 })
              }
              ...mediaFieldsByType
            }
          }
        }
        tags
        productType
        vendor
        availableForSale
        product_type: metafield(namespace: "my_fields", key: "product_type") {
          key
          value
        }
        variants(first: 200) {
          edges {
            node {
              id
              title
              barcode
              priceV2 {
                amount
              }
              compareAtPriceV2 {
                amount
              }
              selectedOptions {
                name
                value
              }
              image {
                src
                url
                id
                height
                width
                altText
              }
              product {
                tags
              }
              availableForSale
              quantityAvailable
              sku
              hexColor: metafield(namespace: "color", key: "hexcolor") {
                key
                value
              }
              olivela_cost: metafield(
                namespace: "my_fields"
                key: "olivela_cost"
              ) {
                key
                value
              }
              baseColor: metafield(namespace: "color", key: "base_color") {
                key
                value
              }
            }
          }
        }
        collections(first: 10) {
          edges {
            node {
              id
            }
          }
        }
        options(first: 100) {
          id
          name
          values
        }
      }
    }
  }
  ${PRODUCT_MEDIA_FIELDS}
`;
